var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-default-portal"},[_c('span',[_vm._v("欢迎使用综合信息化管理平台")])])
}]

export { render, staticRenderFns }